const A4_MM_DIMENSION = Object.freeze({
  width: 210,
  height: 297,
});

export default A4_MM_DIMENSION;
